import React from 'react';

const TrendingTeams = ({ teams }) => {
  const getTrendStyles = (index) => {
    // Simulate trend (in real app, compare with previous period)
    const trends = ['up', 'down', 'stable'];
    const trend = trends[index % 3];

    switch(trend) {
      case 'up':
        return {
          arrow: '↑',
          color: 'text-emerald-400/70',
          bg: 'bg-emerald-500/10',
          border: 'border-emerald-500/20'
        };
      case 'down':
        return {
          arrow: '↓',
          color: 'text-red-400/50',
          bg: 'bg-red-500/10',
          border: 'border-red-500/20'
        };
      default:
        return {
          arrow: '→',
          color: 'text-white/30',
          bg: 'bg-white/5',
          border: 'border-white/10'
        };
    }
  };

  const getRankBadgeStyle = (rank) => {
    if (rank === 1) return 'bg-gradient-to-r from-emerald-500/20 to-violet-500/20 text-emerald-400/90 border-emerald-500/30';
    if (rank <= 3) return 'bg-violet-500/10 text-violet-400/70 border-violet-500/20';
    return 'bg-white/5 text-white/40 border-white/10';
  };

  return (
    <div className="w-full">
      {teams.length === 0 ? (
        <div className="text-center py-8 bg-black/50 border border-white/[0.05]">
          <p className="text-[10px] text-white/30 font-mono uppercase tracking-[0.2em]">
            Nenhum time em destaque
          </p>
        </div>
      ) : (
        <div className="border border-white/[0.05] bg-black/50 overflow-hidden">
          {teams.map((team, index) => {
            const trend = getTrendStyles(index);
            return (
              <div
                key={team.team}
                className="group relative px-4 py-3 hover:bg-white/[0.02] transition-all border-b border-white/[0.03] last:border-b-0"
              >
                <div className="grid grid-cols-12 gap-3 items-center">
                  {/* Rank */}
                  <div className="col-span-1">
                    <span className={`
                      text-[10px] font-mono px-1.5 py-0.5 rounded-sm border
                      ${getRankBadgeStyle(team.rank)}
                    `}>
                      #{team.rank}
                    </span>
                  </div>

                  {/* Team Name */}
                  <div className="col-span-5">
                    <div className="text-xs text-white/90 tracking-wide">
                      {team.team}
                    </div>
                  </div>

                  {/* Picks Count */}
                  <div className="col-span-3">
                    <div className="flex items-baseline gap-1">
                      <span className="text-[11px] font-mono text-white/60">
                        {team.picks}
                      </span>
                      <span className="text-[9px] text-white/30 uppercase tracking-[0.15em]">
                        palpites
                      </span>
                    </div>
                  </div>

                  {/* Percentage */}
                  <div className="col-span-2 text-right">
                    <span className="text-[12px] font-mono text-violet-400/70">
                      {team.percentage}%
                    </span>
                  </div>

                  {/* Trend Indicator */}
                  <div className="col-span-1 text-right">
                    <span className={`
                      inline-flex items-center justify-center w-5 h-5 rounded-full
                      ${trend.bg} ${trend.border} border
                      text-[10px] font-bold ${trend.color}
                    `}>
                      {trend.arrow}
                    </span>
                  </div>
                </div>

                {/* Hover accent line */}
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-emerald-500/0 via-emerald-500/50 to-violet-500/0 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TrendingTeams;